import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	loadingTextNonFinal: {
		id: 'periscope.suggestions.loading-text-non-final',
		defaultMessage: 'Loading more tasks',
		description: 'This is the text displayed while the user loads more work suggestions.',
	},
	pullRequestReviewSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.pull-request-review-suggestions-label-non-final',
		defaultMessage: 'Pull request review',
		description:
			'This is the text label for work suggestions. This is the label for pull request review suggestions',
	},
	pullRequestNeedsToWorkSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.pull-request-needs-to-work-suggestions-label-non-final',
		defaultMessage: 'Pull request changes',
		description:
			'This is the text label for work suggestions. This is the label for pull request needs to work suggestions',
	},
	pullRequestCommentsSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.pull-request-comments-suggestions-label-non-final',
		defaultMessage: 'Pull request comments',
		description:
			'This is the text label for work suggestions. This is the label for pull request comments suggestions',
	},
	compassAnnouncementSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.compass-announcement-suggestions-label-non-final',
		defaultMessage: 'Compass announcements',
		description:
			'This is the text label for work suggestions. This is the label for Compass announcements suggestions',
	},
	failedDeploymentSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.failed-deployment-suggestions-label-non-final',
		defaultMessage: 'Failed deployments',
		description:
			'This is the text label for work suggestions. This is the label for failed deployment suggestions',
	},
	failedBuildSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.failed-build-suggestions-label-non-final',
		defaultMessage: 'Failed builds',
		description:
			'This is the text label for work suggestions. This is the label for failed build suggestions',
	},
	securityVulnerabilitySuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.security-vulnerability-suggestions-label-non-final',
		defaultMessage: 'Security vulnerabilities',
		description:
			'This is the text label for work suggestions. This is the label for security vulnerability suggestions',
	},
	blockingIssuesSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.blocking-issues-suggestions-label-non-final',
		defaultMessage: 'Blocking issues',
		description:
			'This is the text label for work suggestions. This is the label for blocking issues suggestions',
	},
	autodevJobPlanningSuccessSuggestionsLabelNonFinal: {
		id: 'periscope.suggestions.autodev-job-planning-success-suggestions-label-non-final',
		defaultMessage: 'Autodev planning success',
		description:
			'This is the text label for work suggestions. This is the label for Auto development planning success suggestions',
	},
});
